import { render, staticRenderFns } from "./index.vue?vue&type=template&id=154cc4ba"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('154cc4ba')) {
      api.createRecord('154cc4ba', component.options)
    } else {
      api.reload('154cc4ba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=154cc4ba", function () {
      api.rerender('154cc4ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recommended/components/manage/index.vue"
export default component.exports